<template>
  <div :class="video_popup_class" @click="click_close_popup">
    <div class="popup_video_container relative" @click="click_close_popup">
      <img src="../../../static/img/instructions.png" v-if="!is_mobile" />
      <img src="../../../static/img/instructions_mobile.png" v-if="is_mobile" />
    </div>
  </div>
</template>
<script>
export default {
  name: "ImagePopup",
  data() {
    return {
      timer: null
    };
  },
  computed: {
    video_popup_class() {
      return "popup";
    },
    is_mobile() {
      return this.$store.state.browser_is_mobile;
    }
  },
  methods: {
    click_close_popup(e) {
      e.preventDefault();
      this.close_popup(e);
    },
    close_popup(e) {
      console.log("close popup");
      if (this.timer != null) clearTimeout(this.timer);
      this.$store.dispatch("set_popup_state", "");
      this.$store.dispatch("set_simple_val", {
        name: "instructions_shown",
        val: true
      });
    },
    onPopupTimeout() {
      this.close_popup(null);
    }
  },
  mounted() {
    if (this.timer != null) clearTimeout(this.timer);

    this.timer = setTimeout(
      function () {
        this.onPopupTimeout();
      }.bind(this),
      12000
    );
  },
  beforeDestroy() {
    if (this.timer != null) clearTimeout(this.timer);
    this.$bus.$off("on-request-video-close", this.close_popup);
  }
};
</script>
<style scoped>
.popup {
  position: absolute;
  background: rgba(0, 0, 0, 0.3);
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;
  justify-content: center;
  cursor: pointer;
}

.popup_video_container {
  align-self: center;
  margin: 0 0;
}
.popup_video_container img {
  height: auto;
  max-width: 90vw;
  margin: 0 auto;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/popups/InstructionsPopup.vue